class PerformanceCounter {
    updateSignal;
    fps;
    frames;
    lastTime;
    updateIntervalMilliseconds;
    /**
     * Class to calculate the frames per second.
     * @param updateSignal The signal that should be updated when the counter value changes.
     * @param updateIntervalMilliseconds The interval between updates, in milliseconds.
     * @private
     */
    constructor(updateSignal, updateIntervalMilliseconds = 400) {
        this.updateSignal = updateSignal;
        this.fps = 0;
        this.frames = 0;
        this.updateIntervalMilliseconds = updateIntervalMilliseconds;
        this.lastTime = performance.now();
    }
    /**
     * Perform an update.
     * @private
     */
    step() {
        this.frames++;
        const current = performance.now();
        if (current >= this.lastTime + this.updateIntervalMilliseconds) {
            this.fps = Math.round((this.frames * 1000) / (current - this.lastTime));
            this.frames = 0;
            this.lastTime = current;
            this.updateSignal(this.fps);
        }
    }
}
export default PerformanceCounter;
